/**
 * Per-integration logo assets, keyed by the lowercase `IntegrationTypeEnum`
 * values returned by the advertising endpoints. Shared so the advertising tab
 * table and the vehicle-form gap banner render the same portal icons.
 * Falls back to `null` (callers show initials) when a portal has no asset.
 */
export const PORTAL_LOGOS: Record<string, string> = {
  // ponytail: no avtonet key — Quick Entry is unbranded (BRIEFD-7047), so it
  // falls through to the initials chip.
  dober_avto: 'assets/images/img_doberavto.jpeg',
  bolha: 'assets/images/bolha_rounded_logo.png',
  avtoklik: 'assets/images/avtoklik_logo.png',
  trading_hub: 'assets/images/trading-hub-logo.png',
  trading_hub_advertising: 'assets/images/trading-hub-logo.png',
  njuskalo: 'assets/images/njuskalo-logo.png',
  index_hr: 'assets/images/index-hr-logo.png',
  shopaj24: 'assets/images/shopaj24-logo.png',
  facebook: 'assets/images/facebook_logo.png',
  facebook_dynamic_catalog: 'assets/images/facebook_logo.png',
  virtual_salon: 'assets/images/img_digibrief_dashboard.png',
};

/** Logo asset for an integration key, or null when none is available. */
export function portalLogoFor(key: string | null | undefined): string | null {
  return key ? (PORTAL_LOGOS[key] ?? null) : null;
}
